export const theme = {
  colors: {
    primary: '#283618',    // Dark green
    secondary: '#606C38',  // Olive green
    background: '#FEFAE0', // Light cream
    accent1: '#DDA15E',    // Light brown
    accent2: '#BC6C25',    // Dark brown
  }
}; 